import React, { useContext } from 'react';
import MetaContext from '../../contextProviders/MetaContext';

function BoxIcon() {
  const { branding } = useContext(MetaContext);
  const { primaryColor } = branding;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14997_523"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_14997_523)">
        <path
          // eslint-disable-next-line max-len
          d="M19 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 5.79565 0.31607 6.55871 0.87868 7.12132C1.44129 7.68393 2.20435 8 3 8H21C21.7605 8.00929 22.4956 7.72644 23.0538 7.20977C23.612 6.6931 23.9506 5.98198 24 5.223C24.0294 4.54804 23.9219 3.87411 23.6839 3.24183C23.4459 2.60954 23.0823 2.03198 22.6152 1.54395C22.148 1.05593 21.5868 0.66754 20.9655 0.402193C20.3442 0.136846 19.6756 3.37588e-05 19 0Z"
          fill={primaryColor}
        />
        <path
          // eslint-disable-next-line max-len
          d="M22 10H2C1.73479 10 1.48043 10.1054 1.2929 10.2929C1.10536 10.4804 1 10.7348 1 11V19C1.00159 20.3256 1.52888 21.5964 2.46622 22.5338C3.40356 23.4711 4.67441 23.9984 6 24H18C19.3256 23.9984 20.5965 23.4711 21.5338 22.5338C22.4712 21.5964 22.9984 20.3256 23 19V11C23 10.7348 22.8947 10.4804 22.7071 10.2929C22.5196 10.1054 22.2652 10 22 10ZM15 15H9C8.73479 15 8.48043 14.8946 8.2929 14.7071C8.10536 14.5196 8 14.2652 8 14C8 13.7348 8.10536 13.4804 8.2929 13.2929C8.48043 13.1054 8.73479 13 9 13H15C15.2652 13 15.5196 13.1054 15.7071 13.2929C15.8947 13.4804 16 13.7348 16 14C16 14.2652 15.8947 14.5196 15.7071 14.7071C15.5196 14.8946 15.2652 15 15 15Z"
          fill={primaryColor}
        />
      </g>
    </svg>
  );
}

BoxIcon.propTypes = {};

export default BoxIcon;
